<div class="visitor-type-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

  <div class="row">
    <mat-form-field class="flex-grow" *ngIf="visitorRoles != null && visitorRoles.length > 0">
      <mat-label>
        {{'visitor role' |
        translate:['tmc-yard.widgets.filter-administration.details-editor.visit.visitor-role-condition-editor.visitor-role',
        translationService.language]}}
      </mat-label>
      <mat-select formControlName="visitorRole" name="visitorRole">
        <mat-option *ngFor="let o of visitorRoles" [value]="o.id">
          {{o.nameDictionaryKey | translate: [o.nameDictionaryKey, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
